module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('b', [_vm._v("IMPORTANT NAMES")])])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("Arthur Baylis provided testimony as to the valuation of the Reading Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Isabel Benham valuation expert for the Reading Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Charles Bertrand president of the Reading Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Brennan chief financial officer for the Reading Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Bunting CEO of First Pennsylvania Bank")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Joseph (Joe) L. Castle trustee of the Reading Railroad (succeeding Richardson Dilworth upon Dilworth’s death)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Lloyd Cutter lawyer representing the Penn Central Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Richardson (Dick) Dilworth trustee of the Reading Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William (Bill) Dimeling attorney for the Reading Railroad")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William (Bill) Ditter judge in charge of the Reading Railroad’s reorganization")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Richard (Dick) Duzak accountant with Peat Marwick")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Herbert A. Fogel mentor")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("Lockwood (Lock) L. Fogg Jr. special counsel and later secretary and general counsel to the Reading Company")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("John Fowler attorney for the Reading Company")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jim Frick former Reading Railroad employee (returned to help tie up loose ends after conveyance)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Henry Friendly chief judge of special court")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("William Fuchs managing partner of Obermayer, Rebmann, Maxwell and Hippel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Jim Gallagher accountant with Peat Marwick")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Alfred (Bill) W. Hesse senior vice president and general counsel, and later president, of the Reading Company")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Tom Keyser chief financial officer of the Reading Railroad after John Brennan")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Andrew (Drew) L. Lewis trustee of the Reading Railroad and later secretary of transportation")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Bernard (Bernie) G. Meltzer real estate broker and local columnist and radio personality")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Christine Nethesheim attorney for the United States Railway Association")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Hugh Scott US senator")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Doug Segal attorney for the United States Railway Association")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Larry Shiekman partner at Pepper, Hamilton & Scheetz, representing Conrail")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("James (Jim) Alan Sox assistant to Howard Lewis and former law clerk of Judge William Ditter")])]), _c('p', {
    staticClass: "hang"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("Grant Sprecher head of the Litigation Department at Obermayer, Rebmann, Maxwell and Hippel")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "hang"
  }, [_vm._v("Roszel Thomsen judge of special court formed to oversee the railroad’s reorganization")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Stuart Warden former Reading Railroad employee (returned to help tie up loose ends after conveyance)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Harris Weinstein attorney representing Penn Central’s passenger case")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("John Wisdom judge of special court and Fifth Circuit Court of Appeals")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574feb98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_ImportantNames.vue
// module id = 81
// module chunks = 0